<div class="input-container" [style.width]="width" [class.disabled]="disabled">
  <span class="input-title">
    {{ label }}<span *ngIf="required" class="asterisk">*</span>
    @if (disabled) {
      <span class="disabled-indicator">(Disabled)</span>
    }
  </span>
  <mat-form-field [appearance]="appearance" class="custom-input-field" [class.has-error]="hasError()" [class.mat-invalid]="hasError()" floatLabel="always">
    @if (prefixIcon) {
      <ng-container matPrefix>
        @if (prefixIconType === 'material') {
          <mat-icon class="prefix-icon material-icon">{{ prefixIcon }}</mat-icon>
        }
        @if (prefixIconType === 'png') {
          <img [src]="prefixIcon"
               class="prefix-icon png-icon"
               alt="prefix icon">
        }
      </ng-container>
    }
    <input matInput
      [formControl]="control"
      [type]="type"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [required]="required"
      [readonly]="readonly"
      [attr.minlength]="minLength"
      [attr.maxlength]="maxLength"
      [min]="min"
      [max]="max"
      [pattern]="pattern || ''"
      [autocomplete]="autocomplete"
      (input)="handleInput($event)"
      (blur)="blur.emit($event)"
      (focus)="focus.emit($event)"
      (keypress)="onKeyPress($event)">

    <ng-container matSuffix style="display: flex; align-items: center;">
      <ng-content select="[matSuffix]"></ng-content>
      @if (showClearButton && value && !disabled && !readonly) {
        <button mat-icon-button
          (click)="clearValue()"
          type="button"
          class="clear-button">
          <mat-icon>close</mat-icon>
        </button>
      }
    </ng-container>

      @if (hasError()) {
        <mat-error>{{ customErrorMessages ? customErrorMessages : getErrorMessage() }}</mat-error>
      }
  </mat-form-field>
</div>
